import styled, { type CSSProperties } from 'styled-components'

export type ContainerSize = 'wide' | 'med' | 'small' | 'narrow' | 'normal'

const ContainerWidth: Record<ContainerSize, number | undefined> = {
  wide: 1298,
  med: 1136,
  small: 1008, // 960px + (24px * 2) for horizontal padding
  narrow: 684,
  normal: undefined,
}

export const Container = styled.div<{
  $size?: ContainerSize
  $padding?: 'no-mobile'
  $flex?: boolean
  $align?: 'center' | 'top'
  $direction?: CSSProperties['flexDirection']
  $height?: CSSProperties['height']
}>`
  width: 100%;
  max-width: 1008px;
  margin: 0 auto;
  padding: 0 24px;
  ${(props) => {
    const maxWidth = props.$size && ContainerWidth[props.$size]
    return maxWidth ? `max-width: ${maxWidth}px;` : undefined
  }}
  ${(props) => props.$flex && `display:flex;`}
  ${(props) => props.$align === 'center' && `align-items: center;`}
  ${(props) => props.$align === 'top' && `align-items: flex-start;`}
  ${(props) => props.$direction && `flex-direction: ${props.$direction};`}
  @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    padding: 0 20px;
    ${(props) => props.$padding === 'no-mobile' && `padding: 0;`}
    ${(props) => props.$flex && `flex-direction:column;`}
  }
  ${(props) => !!props.$height && `height: ${props.$height};`}
`
